import React, { useContext } from "react";
import MediaQuery from "react-responsive";
import ServerContext from "common/utils/serverContext";

interface IProps {
  children: React.ReactNode;
  className?: string;
}

const Desktop = ({ children, className }: IProps) => {
  const { isMobile } = useContext(ServerContext);
  const values = isMobile ? {} : { deviceWidth: 1200 };
  return (
    <div className={className}>
      <MediaQuery minWidth={1024} values={values}>
        {children}
      </MediaQuery>
    </div>
  );
};

export default Desktop;
